import React, { Component } from 'react';
import { toast } from 'react-toastify';
import {
  Modal,
  Button,
  FileUploader,
  TextArea,
  ProgressIndicatorSkeleton,
} from 'carbon-components-react';
import Select from 'react-select';
import queryString from 'qs';
import NumberFormat from 'react-number-format';

import { Breadcrumb, Card } from '../../../../components';
import {
  getByDmService,
  deleteDmService,
  insertDmService,
  updateDmService,
} from '../../../../services/Api';
import appConfig from '../../../../config/app-config';

import 'numeral/locales/pt-br';

const { IMAGE_PATH } = appConfig;

class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tipos: [],
      tipoSelecionado: { id: 0 },
      uploads: [],
    };
  }

  componentDidMount = async () => {
    await this.getItems();
  };

  goUrl = () => {
    const { history } = this.props;
    const urlGo = '/admin/produtos/2';
    history.push(urlGo);
  };

  getItems = async () => {
    const { match, location } = this.props;

    let data = { produtoCategoria: { id: 0, tipo: 1 } };
    const query = queryString.parse(location.search.slice(1));

    const { msg } = query;
    if (msg) {
      toast.success(msg);
    }
    try {
      if (Number(match.params.id) === 0) {
        data = { produtoCategoria: { id: 0 } };
      } else {
        data = await getByDmService('/Produto', match.params.id);
        console.log("test data")
        console.log(data)

      }
      const tipos = [{ id: '1', label: 'Agência' }, { id: '2', label: 'Trade' }];
      const tipoSelecionado = tipos.find(el => el.id === data.produtoCategoria.tipo) || {
        id: '2',
        label: 'Trade',
      };

      this.setState(
        {
          ...data,
          isLoading: false,
          tipoSelecionado,
          tipos,
        },
        async () => {
          await this.loadCategories(data.produtoCategoria.id);
        },
      );
    } catch (e) {
      if (e.message) toast.error(e.message);
      else toast.error('Ocorreu um erro ao carregar os dados');
      // this.setState({ data: null, error: e, isLoading: false });
    }
  };

  loadCategories = async selectedId => {
    const { tipoSelecionado } = this.state;

    let categorias = [];
    const cat = await getByDmService('/ProdutoCategoria/GetByTipo', `?tipo=${tipoSelecionado.id}`);
    categorias = cat.map(item => ({ id: item.id, label: item.nome }));
    const categoriaSelecionada = categorias.find(el => el.id === selectedId);
    this.setState({ categoriaSelecionada, categorias });
  };

  onChangeText = (event, value) => {
    if (value) {
      this.setState({ [event.target.name]: value });
    } else {
      this.setState({ [event.target.name]: event.target.value });
    }
  };

  onChangeCategoria = categoria => {
    this.setState({ categoriaSelecionada: categoria });
  };

  onChangeTipo = tipo => {
    if (tipo.id === '1') this.props.history.push('/admin/produto-agencia/0');
  };

  onChangeMessage = event => {
    this.setState({ descricao: event.target.value });
  };

  fileChange = async (e, name) => {
    const { match } = this.props;
    const { files } = document.getElementsByName(name)[0];
    if (files.length > 0) {
      if (match.params.id > 0) {
        const _files = [];
        for (let i = 0; i < files.length; i++) _files.push(files[i]);

        await this.uploadFileArray(_files, match.params.id);
        await this.reloadFotos();
        this.fileUploader.clearFiles();
      } else {
        this.setState(prevState => {
          const uploads = prevState.uploads || [];
          for (let i = 0; i < files.length; i++) uploads.push(files[i]);
          return { ...prevState, uploads };
        });
      }
    }
  };

  uploadFileArray = async (files, id) => {
    await Promise.all(
      files.map(async file => {
        try {
          const data = new FormData();
          data.append('file', file);
          await insertDmService(`/Produto/Upload?idProduto=${id}&principal=false`, data);
        } catch (err) {
          toast.error('Falha ao fazer upload da foto');
        }
      }),
    );
  };

  deleteFoto = async id => {
    try {
      await deleteDmService('/Produto/DeleteFoto', id);
      await this.reloadFotos();
    } catch (err) {
      toast.error(err.message);
    }
  };

  reloadFotos = async () => {
    const { match } = this.props;
    const data = await getByDmService('/Produto', match.params.id);
    this.setState({ fotos: data.fotos });
  };

  salvar = async () => {
    const { match } = this.props;
    const { categoriaSelecionada, preco, estoque, codigo, nome, descricao, uploads } = this.state;
    try {
      const data = {
        ProdutoCategoria: { id: categoriaSelecionada.id },
        Nome: nome,
        Codigo: codigo,
        Preco: preco,
        Estoque: estoque,
        Descricao: descricao,
      };
      if (match.params.id && match.params.id > 0)
        await updateDmService('Produto', match.params.id, data);
      else {
        const result = await insertDmService('Produto', data);
        if (uploads.length > 0) await this.uploadFileArray(uploads, result.id);
      }
      this.goUrl();
    } catch (e) {
      toast.error('Falha ao salvar os dados');
    }
  };

  criarCategoria = async () => {
    const { tipoSelecionado, descricaoCategoria, nomeCategoria } = this.state;
    try {
      const data = {
        Tipo: tipoSelecionado.id,
        Nome: nomeCategoria,
        Descricao: descricaoCategoria,
      };
      const cat = await insertDmService('ProdutoCategoria', data);

      await this.loadCategories(cat.id);
      this.setState({ categoriaModal: false });
    } catch (e) {
      toast.error('Falha ao criar categoria');
    }
  };

  deletarProduto = async () => {
    const { match } = this.props;
    try {
      await deleteDmService('Produto', match.params.id);
      toast.success('Item excluído com sucesso');
      this.setState({ deleteModal: false });
      this.goUrl();
    } catch (e) {
      
      toast.error(e.message);
    }
  };

  onsubmit = e => {
    e.preventDefault();
    if (e.target.checkValidity()) {
      this.salvar();
    }
  };

  cleseModal = modal => {
    this.setState({ [modal]: false });
  };

  openModal = modal => {
    this.setState({ [modal]: true });
  };

  cancel = () => {
    this.goUrl();
  };

  render() {
    const {
      isLoading,
      nome,
      codigo,
      preco,
      estoque,
      fotos,
      categoriaSelecionada,
      categorias,
      tipos,
      tipoSelecionado,
      descricao,
      deleteModal,
      categoriaModal,
      descricaoCategoria,
      nomeCategoria,
      data
    } = this.state;
    const { match } = this.props;
    const idProd = data && data.codigo ? data.codigo : "";

    if (isLoading) {
      return (
        <div>
          <Breadcrumb title="---- - ----" description="----" />
          <section className="content-wrapper content-wrapper--large">
            <ProgressIndicatorSkeleton />
          </section>
        </div>
      );
    }

    return (
      <div>
        {!isLoading && (
          <div>
            <Breadcrumb
              title="Produto Trade"
              description={nome}
              renderRight={
                match.params.id > 0 &&
                (() => (
                  <button
                    onClick={() => {
                      this.openModal('deleteModal');
                    }}
                    type="submit"
                    className="bx--btn btn-primary-outlined h-sm-margin"
                  >
                    Excluir Produto
                  </button>
                ))()
              }
              renderLeft={(() => (
                <div className="breadcrumb-left-actions pointer" onClick={() => this.goUrl()}>
                  <svg width="16" height="14" viewBox="0 0 16 14">
                    <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                  </svg>
                </div>
              ))()}
            />
            <section className="content-wrapper content-wrapper--large product-edit">
              <div className="table-uniforms">
                <Card className="center-box">
                  <form onSubmit={this.onsubmit}>
                    <div className="mg-left-20">
                      {idProd !== "" && (
                        <div className="row">
                          <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                            <label className="bx--label">
                              ID DO PRODUTO:
                              {` ${idProd}`}
                            </label>
                          </div>
                        </div>
                      )}
                      <div className="bx--row">
                        
                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label">Tipo</label>
                          <Select
                            className="search-dm"
                            name="tipo"
                            required
                            options={tipos}
                            value={tipoSelecionado}
                            onChange={this.onChangeTipo}
                            placeholder="Tipo"
                            isClearable={false}
                            isSearchable
                          />
                        </div>
                      </div>
                      <div className="bx--row">
                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label">Categoria</label>
                          <Select
                            className="search-dm"
                            name="categorias"
                            options={categorias}
                            required
                            value={categoriaSelecionada}
                            onChange={this.onChangeCategoria}
                            placeholder="Categoria"
                            isClearable={false}
                            isSearchable
                          />
                        </div>
                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label">&nbsp;</label>
                          <div className="clearfix" />
                          <a
                            className="gerenciar-categoria"
                            onClick={() => {
                              this.openModal('categoriaModal');
                            }}
                          >
                            Gerenciar categoria
                          </a>
                        </div>
                      </div>
                      <div className="bx--row">
                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label">Código</label>
                          <input
                            type="text"
                            className="bx--text-input"
                            required
                            placeholder="47734434"
                            name="codigo"
                            value={codigo}
                            onChange={this.onChangeText}
                          />
                        </div>
                      </div>
                      <div className="bx--row">
                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label">Nome do Produto</label>
                          <input
                            type="text"
                            className="bx--text-input"
                            required
                            placeholder=" Base para Celular "
                            name="nome"
                            value={nome}
                            onChange={this.onChangeText}
                          />
                        </div>
                        <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                          <label className="bx--label">Preço</label>
                          <NumberFormat
                            getInputRef={ref => {
                              this.precoRef = ref;
                            }}
                            id="preco"
                            className="bx--text-input bx--text__input"
                            decimalSeparator=","
                            prefix="R$ "
                            fixedDecimalScale
                            thousandSeparator="."
                            placeholder="R$ 0,00"
                            value={preco}
                            allowNegative={false}
                            decimalScale={2}
                            onValueChange={(values, e) => {
                              this.setState({
                                [e.target.id]: values.value ? Number(values.value) : null,
                                isEdited: true,
                              });
                            }}
                            onFocus={() => {
                              if (!preco && this.precoRef) {
                                this.precoRef.value = '';
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div className="bx--row">
                        <div className="bx--col-xs-12">
                          <TextArea
                            labelText="Descrição"
                            name="descricao"
                            value={descricao}
                            onChange={this.onChangeText}
                            placeholder="Digite"
                          />
                        </div>
                      </div>
                      <div className="bx--row">
                        <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                          <label className="bx--label">Estoque</label>
                          <input
                            type="number"
                            className="bx--text-input"
                            required
                            placeholder="5"
                            name="estoque"
                            value={estoque}
                            onChange={this.onChangeText}
                          />
                        </div>
                      </div>
                      <div className="bx--row">
                        <FileUploader
                          labelTitle="Imagens"
                          labelDescription=" Máx 500x500 px / 500kb "
                          buttonLabel="Upload"
                          filenameStatus="edit"
                          onChange={async e => {
                            await this.fileChange(e, 'imagens');
                          }}
                          buttonKind="secondary"
                          multiple
                          ref={fileUploader => (this.fileUploader = fileUploader)}
                          accept={['.jpg', '.png']}
                          name="imagens"
                        />
                      </div>
                      <div className="bx--row">
                        {fotos &&
                          fotos.map(foto => (
                            <div style={{ width: '100%', marginTop: '10px' }}>
                              <div className="clearfix" />
                              <img
                                src={IMAGE_PATH + foto.caminho}
                                alt="Miniatura"
                                className="img-produto-miniatura"
                              />
                              <div className="bx--file-container">
                                <span className="bx--file__selected-file" kind="secondary">
                                  <p className="bx--file-filename">
                                    {' '}
                                    {foto.caminho && foto.caminho.split('/').pop()}
                                    {' '}
                                  </p>
                                  <span
                                    className="bx--file__state-container"
                                    onClick={async () => {
                                      await this.deleteFoto(foto.id);
                                    }}
                                  >
                                    <svg
                                      className="bx--file-close"
                                      fillRule="evenodd"
                                      height="16"
                                      role="img"
                                      viewBox="0 0 16 16"
                                      width="16"
                                      tabIndex="0"
                                      aria-label="Provide icon description"
                                      alt="Provide icon description"
                                    >
                                      <title>Provide icon description</title>
                                      <path d="M8 6.586L5.879 4.464 4.464 5.88 6.586 8l-2.122 2.121 1.415 1.415L8 9.414l2.121 2.122 1.415-1.415L9.414 8l2.122-2.121-1.415-1.415L8 6.586zM8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
                                    </svg>
                                  </span>
                                </span>
                              </div>
                            </div>
                          ))}
                      </div>
                      <div className="bx--row" style={{ marginTop: '40px' }}>
                        <div className="bx--col-xs-12 v-md-margin">
                          <Button type="submit">Salvar</Button>
                          <a onClick={() => this.cancel()} className="bx--link mg-left-20 pointer">
                            Cancelar
                          </a>
                        </div>
                      </div>
                    </div>
                  </form>
                </Card>
              </div>
              <Modal
                modalHeading="Remover Produto"
                primaryButtonText="Confirmar"
                secondaryButtonText="Cancelar"
                onRequestSubmit={this.deletarProduto}
                onRequestClose={() => this.cleseModal('deleteModal')}
                open={deleteModal}
              >
                <p>Você deseja realmente deletar este produto?</p>
              </Modal>
              <Modal
                open={categoriaModal}
                onRequestSubmit={async () => {
                  await this.criarCategoria();
                }}
                onRequestClose={() => this.cleseModal('categoriaModal')}
                modalHeading="Criar Categoria"
                primaryButtonText="Confirmar"
                secondaryButtonText="Cancelar"
                primaryButtonDisabled={!(nomeCategoria && descricaoCategoria)}
              >
                <div>
                  <div className="bx--row">
                    <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                      <label className="bx--label">Nome da categoria</label>
                      <input
                        type="text"
                        className="bx--text-input"
                        required
                        placeholder="Nome"
                        name="nomeCategoria"
                        value={nomeCategoria}
                        onChange={this.onChangeText}
                      />
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-xs-12">
                      <TextArea
                        labelText="Descrição"
                        name="descricaoCategoria"
                        value={descricaoCategoria}
                        onChange={this.onChangeText}
                        placeholder="Digite"
                      />
                    </div>
                  </div>
                </div>
              </Modal>
            </section>
          </div>
        )}
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/screens/admin/Products/Edit/Main.js